import {
    FETCH_ALL_STATIC_DATA_SUCCESS, FETCH_ALL_STATIC_DATA_SUCCESS_NEW, FETCH_FOOD_GROUPS_DATA_SUCCESS,
    FETCH_PLAN_STATIC_DATA_SUCCESS,
    FETCH_ROUTINE_ATTRIBUTE_DATA_SUCCESS
} from "./ActionTypes"
import {IStaticDataResponse} from "../models/staticData/IStaticDataResponse"
import {ApiManager} from "../api/ApiManager"
import {IStaticDataRequestParams} from "../models/request/IStaticDataRequestParams"
import {StaticDataRequestParamsBuilder} from "../builder/StaticDataRequestParamsBuilder"
import IDiagnosticSuggestions from "../models/IDiagnosticSuggestions";
import RoutineAttribute from "../models/staticData/RoutineAttribute";
import IFoodCategory from "../models/IFoodCategory";
import IFetchMealsByCaloriesRequest from "../models/IFetchMealsByCaloriesRequest";
import IMealItem from "../models/IMealItem";
import IPlanStaticData from "../models/staticData/IPlanStaticData"

export class AllStaticDataActions {

    static fetchCovidMetricIds() {
        return ApiManager.getAlbusApis().getCovidMetrics();
    }

    /* Action Creators */
    static fetchAllStaticDataSuccess(allStaticData: IStaticDataResponse) {
        return {type: FETCH_ALL_STATIC_DATA_SUCCESS, allStaticData: allStaticData};
    }

    static fetchPlanStaticDataSuccess(planStaticData: IPlanStaticData) {
        return {type: FETCH_PLAN_STATIC_DATA_SUCCESS, planStaticData: planStaticData};
    }

    static fetchRoutineDataSuccess(routineAttr: RoutineAttribute) {
        return {type: FETCH_ROUTINE_ATTRIBUTE_DATA_SUCCESS, routineAttr: routineAttr}
    }

    static fetchStaticFoodGroupsSuccess(foodGroups: IFoodCategory[]) {
        return {type: FETCH_FOOD_GROUPS_DATA_SUCCESS, foodGroups}
    }

    static fetchAllStaticData(dispatch: any): void {
        let reqParamsBuilder: StaticDataRequestParamsBuilder = new StaticDataRequestParamsBuilder();
        let staticDataRequestParams: IStaticDataRequestParams = reqParamsBuilder.setVitalRequired().setComorbidConditionRequired()
            .setHabitRequired().setGeneralExaminationRequired().setDoctorSpecialityCodeRequired().setMedicineTypeRequired()
            .setConsultationTypeRequired().setSystematicExaminationRequired().build()
        ApiManager.getAlbusApis().getStaticData(staticDataRequestParams).then((allStaticData: IStaticDataResponse) => {
            dispatch(AllStaticDataActions.fetchAllStaticDataSuccess(allStaticData));
        });
    }

    static getAllConsolidatedStaticData(dispatch: any): Promise<any> {
        return ApiManager.getOrionApis().getStaticDietRecallData().then((staticDietRecallData: any) => {
            dispatch({type: FETCH_ALL_STATIC_DATA_SUCCESS_NEW, allStaticData: staticDietRecallData})
        })
    }

    static fetchPlanStaticData(dispatch: any): void {
        ApiManager.getOrionApis().getPlanStaticData().then((planStaticData: IPlanStaticData) => {
           dispatch(AllStaticDataActions.fetchPlanStaticDataSuccess(planStaticData));
        });
    }

    static fetchStaticTestsData(input: string): Promise<IDiagnosticSuggestions[]> {
        return ApiManager.getAlbusApis().getDiagnosticSuggestions(input);
    }

    static fetchStaticDiseaseData(input: string): Promise<any[]> {
        return ApiManager.getAlbusApis().getDiseaseByName(input);
    }

    static fetchStaticSymptomsData(input: string): Promise<any[]> {
        return ApiManager.getAlbusApis().getSymptomsByName(input);
    }

    static fetchStaticLifeStyleData(input: string): Promise<any[]> {
        return ApiManager.getAlbusApis().getLifeStyleByName(input);
    }

    static fetchStaticRoutineAttr = () => {
        return ApiManager.getAlbusApis().fetchStaticRoutineAttr()
    }

    static fetchStaticFoodGroups = (dispatch: any) => {
        ApiManager.getRamsayApis().getFoodGroups().then((foodGroups: IFoodCategory[]) => {
            dispatch(AllStaticDataActions.fetchStaticFoodGroupsSuccess(foodGroups));
        })
    }

    static fetchStaticMealsByCalorieBreakup = (calorieBreakup: IFetchMealsByCaloriesRequest) => {
        return ApiManager.getRamsayApis().fetchMealsByCalorieBreakup(calorieBreakup);
    }

    static fetchStaticDishesByDishName = (input: string) => {
        return ApiManager.getMaverickApis().getDishByDishName(input);
    }

    static fetchMealByMealId = (mealId: string) => {
        return ApiManager.getRamsayApis().getMealByMealId(mealId);
    }

    static previewMeal = (meal: IMealItem) => {
        return ApiManager.getRamsayApis().previewMeal(meal);
    }

    static createMeal = (meal: IMealItem) => {
        return ApiManager.getRamsayApis().createMeal(meal);
    }

    static fetchStaticDietGuidelines = (input: string, category: string) => {
        return ApiManager.getMaverickApis().getDietGuidelinesByCategory(input, category);
    }

    static fetchStaticDiagnosticLabTests = (input: string) => {
        return ApiManager.getMetricServiceApis().fetchStaticDiagnosticLabTests(input);
    }
}